import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "meta",
  class: "_main"
}
const _hoisted_2 = { class: "_header" }
const _hoisted_3 = { class: "_headerBack" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, " PWA ", -1)
const _hoisted_5 = { class: "section" }
const _hoisted_6 = { class: "_back" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Return", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h1", { class: "header" }, " Progressive Web Application ", -1)
const _hoisted_9 = { class: "_content" }
const _hoisted_10 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, " Last updated 5th Jan 2022 ", -1)
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<h2 class=\"subheader\"> What is a PWA? </h2><div class=\"_content\"><p> Referring to Mozilla&#39;s excellent <a href=\"https://developer.mozilla.org/en-US/docs/Web/Progressive_web_apps\">documentation on PWA&#39;s</a>, in short, a PWA is an installable web app. Browsers can install a copy of the website on your device which runs like a native application. The PWA offers one distinct advantage over a website experience: ease of use. By installing the app, you have it saved on your device like a program or mobile app. This allows you, for example, to open the website in a dedicated window from your desktop or mobile device home screen. </p></div><h2 class=\"subheader\"> Any security concerns? </h2><div class=\"_content\"><p> At current, PWA&#39;s offer the security features and experiences users have come to love from modern browsers. We utilise no additional functionality nor methods for obtaining user data from someone installing and running a PWA. </p></div><div class=\"_footer _content\"><h4>Advisory</h4><p> Not all devices support PWA functionality - accordingly, if you do not see a &quot;Install PWA&quot; button under this page&#39;s header, or in the navigation pane, then you cannot utilise this feature. </p></div>", 5)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_IconButton, {
          icon: "back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({path:'/policy'}))),
          white: true
        })
      ]),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_IconButton, {
          icon: "back",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({path:'/policy'})))
        }),
        _hoisted_7
      ]),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        (!_ctx.$store.state.Utils.PWAPrompt)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_10, "PWA not supported or detected on this browser or device."))
          : (_openBlock(), _createElementBlock("p", _hoisted_11, [
              _createVNode(_component_IconButton, {
                text: "Install PWA",
                icon: "download",
                onClick: _ctx.triggerInstall
              }, null, 8, ["onClick"])
            ])),
        _hoisted_12
      ]),
      _hoisted_13
    ])
  ]))
}